/*
 * @Description:
 * @Version: 2.0
 * @Autor: zhangkai
 * @Date: 2021-03-22 11:13:33
 * @LastEditors: zhangkai
 * @LastEditTime: 2021-03-22 11:14:02
 * @FilePath: /advance/src/brandSpace/utils/main-logadmin.js
 */
import Vue from 'vue'
// import XesLoggerSDK from '@xes/xes_fe_log'
import { XesChannel, XesShare, XesTalLogin } from '@xes/terra-utils'
import { Toast, Dialog, Lazyload, Popup } from 'vant'
import '@/common/less/base/reset.less'
import '@/common/less/base/common.less'
import '@/common/utils/xesDebug' // 移动端调试
import '@/common/utils/xesTalSdk' // 引入集团JSSDK文件
import XesLoggerAdmin from '@xes/terra-utils/lib/XesLoggerAdmin'
import XesLoggerAdminNew from '@xes/xes_fe_log_logadmin'
Vue.config.productionTip = false

// 热点投放
window._wltfChannel = new XesChannel()
window._xesShare = new XesShare()
Vue.prototype.$xesTalLogin = new XesTalLogin({
  env: window._wltfChannel.urlParams.env
})

Vue.use(Toast)
  .use(Dialog)
  .use(Lazyload)
  .use(Popup)

const initLogSDK = options => {
  if (!options) {
    console.error('请传入logId')
    return
  }
  Vue.prototype.$xesLogger = new XesLoggerAdmin(options, Vue)
  // Vue.use(XesLoggerAdmin, options)
  // Vue.component(XesLoggerAdmin, options)
  // console.log('XesLoggerAdmin', new XesLoggerAdmin(options, Vue))
  Vue.prototype.$xesLogger.setCommonParam({
    sourceid:
      window._wltfChannel.urlParams.xeswx_sourceid ||
      window._wltfChannel.hotUrlParams.source ||
      window._wltfChannel.urlParams.sourceid ||
      window._wltfChannel.urlParams.sourceId ||
      ''
  })
}

const initLogSDKNew = options => {
  if (!options) {
    console.error('请传入logId')
    return
  }
  Vue.prototype.$xesLogger = new XesLoggerAdminNew(options, Vue)
  // Vue.use(XesLoggerAdminNew, options)
  // Vue.component(XesLoggerAdminNew, options)
  // console.log('XesLoggerAdmin', new XesLoggerAdmin(options, Vue))
  Vue.prototype.$xesLogger.setCommonParam({
    sourceid:
      window._wltfChannel.urlParams.xeswx_sourceid ||
      window._wltfChannel.hotUrlParams.source ||
      window._wltfChannel.urlParams.sourceid ||
      window._wltfChannel.urlParams.sourceId ||
      ''
  })
}

export { initLogSDK, initLogSDKNew }
